// 处理url相关的工具方法

/**
 * 从类似”?a=123&b=123“中解析参数 （不能解析特殊字符）
 * @param {string} search
 * @returns {Object<string, string>}
 */
export function getQueryFromQuery(search = location.search) {
    const query = {};
    if (search.indexOf('?') === 0) search = search.slice(1);
    search.split('&').forEach(str => {
        if (!str) return;
        const arr = str.split('=');
        query[arr[0]] = decodeURIComponent(arr[1]);
    });
    return query;
}

/**
 * 新版 获取url上的参数
 * @param {any} search url上参数
 */

export function getLocationQuery(params = location.search) {
    const pattern = /([^?&=]+)=([^&#]*)/g;
    const dict = {};
    let search = null;
    if (typeof params === 'object' && params instanceof Location) {
        search = params.search;
    } else if (typeof params === 'string') {
        search = params;
    } else {
        throw new Error('参数类型非法！请传入window.loaction对象或者url字符串。');
    }
    search.replace(pattern, function(rs, $1, $2) {
        const key = decodeURIComponent($1);
        const value = decodeURIComponent($2);
        dict[key] = value;
        return rs;
    });
    return dict;
}

/**
 * 获取url的哈希部分
 * @param {string} url
 */
export function getHash(url) {
    const hashMatch = url.match(/#.*/);
    return hashMatch ? hashMatch[0] : '';
}

/**
 * 获取url的查询部分
 * @param {string} url
 */
export function getSearch(url) {
    url = url.replace(getHash(url), ''); // 先去除hash
    const queryMatch = url.match(/\?[^#]*/);
    return queryMatch ? queryMatch[0] : '';
}

/**
 * 获取url域名
 * @param {string} url
 */
export function getHost(url) {
    const hostMatch = url.match(/\/\/([^/]+)/);
    return hostMatch ? hostMatch[1] : '';
}

/**
 * 获取url去除search和hash部分
 * @param {string} url
 */
export function getOrigin(url) {
    const hash = getHash(url);
    const search = getSearch(url);
    return url.replace(search, '').replace(hash, '');
}

/**
 * 解构url
 * @param {string} url
 */
export function parseUrl(url) {
    const hash = getHash(url);
    const search = getSearch(url);
    const host = getHost(url);
    const origin = getOrigin(url);
    return {
        origin,
        search,
        hash,
        host,
    };
}

export default {
    /**
     * 从类似”?a=123&b=123“中解析参数
     */
    getQueryFromQuery,
    /**
     * 从url中解析参数，返回object
     * @param {string} url
     * @param {Object} option 选项
     * @param {boolean} option.fromHash 是否从hash中提取参数
     * @returns {Object<string, string>}
     */
    getQuery(url = location.href, option = {}) {
        const { fromHash } = option;
        let search = fromHash ? getSearch(getHash(url).slice(1)) : getSearch(url);
        if (!search) return {};
        return getQueryFromQuery(search);
    },
    /**
     * object转”a=123&b=123“
     * @param {Object<string,*>} query
     * @param {{dontEncode:[string]}} option
     * @returns {string}
     */
    queryToString(query, option = {}) {
        if (!query) return '';
        const dontEncode = option.dontEncode || [];
        return Object.entries(query)
            .map(([key, value]) => {
                if (value === undefined || value === null) return '';
                return `${key}=${dontEncode.includes(key) ? value : encodeURIComponent(value)}`;
            })
            .filter(s => s)
            .join('&');
    },
    /**
     * 往url的query参数里加参数
     * 如果希望往hash里面塞参数，请使用pushQuery(location.hash.slice(1),{...})
     * @param {string} url
     * @param {*} query
     * @param {{dontEncode:[string]}} option
     */
    pushQuery(url, query, option = {}) {
        const dontEncode = option.dontEncode || [];
        const hash = getHash(url);
        const oldQuery = this.getQuery(url, { fromHash: option.fromHash });
        Object.assign(oldQuery, query);
        const origin = url.split(/[?#]/)[0];
        return `${origin}?${this.queryToString(oldQuery, { dontEncode })}${hash}`;
    },
};

// 判断字符串是不是url
export function validURL(str) {
    const pattern = /^(((ht|f)tps?):\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/;
    return pattern.test(str);
}
